/**
 * Schema estruturado para breadcrumbs
 * Ajuda os mecanismos de busca a entender a estrutura do site
 * @param {string} currentPage - Nome da página atual
 * @param {string} currentUrl - URL completa da página atual
 * @returns {Object} Schema estruturado para breadcrumbs
 */
export const generateBreadcrumbSchema = (currentPage, currentUrl) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': [
      {
        '@type': 'ListItem',
        'position': 1,
        'name': 'Home',
        'item': 'https://calculadora-juros-compostos.com'
      },
      {
        '@type': 'ListItem',
        'position': 2,
        'name': currentPage,
        'item': currentUrl
      }
    ]
  };
};

/**
 * Schema de breadcrumb para página com caminho mais profundo
 * @param {Array} path - Array com o caminho completo [nome1, nome2, ...]
 * @param {Array} urls - Array com URLs correspondentes a cada nível
 * @returns {Object} Schema estruturado para breadcrumbs
 */
export const generateDeepBreadcrumbSchema = (path, urls) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': path.map((name, index) => ({
      '@type': 'ListItem',
      'position': index + 1,
      'name': name,
      'item': urls[index]
    }))
  };
};
